








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class PGGroup extends Vue {
  @Prop() title!: string;
  activeNames: string[] = ['1'];

  get curMDDesignId(): string {
    return this.$store.state.ModuleMD.curMDDesignId;
  }
}
